"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProfileMediaModeEnum = void 0;
/**
 * Режимы использования медиа в профиле
 */
var ProfileMediaModeEnum;
(function (ProfileMediaModeEnum) {
  /**
   * Вывод медиа с использованием внешней ссылки (youtube/vimeo)
   */
  ProfileMediaModeEnum[ProfileMediaModeEnum["use_media_url"] = 1] = "use_media_url";
  /**
   * Вывод медиа с использованием файла, загруженного в файловое хранилище
   */
  ProfileMediaModeEnum[ProfileMediaModeEnum["use_media_id"] = 2] = "use_media_id";
})(ProfileMediaModeEnum = exports.ProfileMediaModeEnum || (exports.ProfileMediaModeEnum = {}));
